
import React from "react";
import { Investor, Contact } from "@/types/investor";
import EmailDrafts from "./EmailDrafts";
import EmailDraftToggle from "./EmailDraftToggle";
import EmailActionButtons from "./EmailActionButtons";
import { Card } from "@/components/ui/card";
import { EmailDraft } from "@/utils/investors/draftUtils";
import { useEmailActions, EmailActionsProps } from "@/hooks/useEmailActions";

const EmailActionsPanel: React.FC<EmailActionsProps> = (props) => {
  const {
    drafts,
    selectedDraftId,
    showDrafts,
    emailSent,
    isSending,
    handleCopyToClipboard,
    handleDownload,
    handleSaveAsDraft,
    handleSendEmail,
    handleSelectDraft,
    handleDeleteDraft,
    handleLabelDraft,
    handleRegenerateDraft,
    handleToggleDrafts
  } = useEmailActions(props);

  return (
    <div className="space-y-4">
      <div className="flex justify-between">
        <EmailDraftToggle 
          showDrafts={showDrafts}
          draftsCount={drafts.length}
          onToggleDrafts={handleToggleDrafts}
        />
        
        <EmailActionButtons
          generatedEmail={props.generatedEmail}
          emailSent={emailSent}
          isSending={isSending}
          onSaveAsDraft={handleSaveAsDraft}
          onCopyToClipboard={handleCopyToClipboard}
          onDownload={handleDownload}
          onSendEmail={handleSendEmail}
        />
      </div>
      
      {showDrafts && (
        <Card className="p-3">
          <EmailDrafts
            drafts={drafts}
            selectedDraftId={selectedDraftId}
            onSelectDraft={handleSelectDraft}
            onDeleteDraft={handleDeleteDraft}
            onLabelDraft={handleLabelDraft}
            onRegenerateDraft={handleRegenerateDraft}
            isLoading={props.isLoading}
          />
        </Card>
      )}
    </div>
  );
};

export default EmailActionsPanel;
